import React, { PropTypes } from 'react';
import cx from 'classnames';
import { assetAt } from 'utils/assets';
import fetch from 'utils/fetch';
import AsyncImage from './AsyncImage';
import { extractYoutubeId } from 'utils/youtube';

const videoThumbnailUrl = thumbnail =>
  thumbnail || assetAt('images/placeholder.png');

export default class YoutubeVideo extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    thumbnail: PropTypes.string,
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      thumbnail: props.thumbnail,
    };

    this.onChangeLink = this.onChangeLink.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  componentWillMount() {
    const { value, thumbnail } = this.props;
    if (value && !thumbnail) {
      const youtubeId = extractYoutubeId(value);
      this._loadYoutubeThumbnail(youtubeId);
    }
  }

  onChangeLink(evt) {
    const value = evt.target.value;
    this.setState({
      value,
    });

    const youtubeId = extractYoutubeId(value);
    if (youtubeId) {
      this.setState({
        inError: false,
        loading: true,
      });

      // Loading thumbnail for given youtube ID
      this._loadYoutubeThumbnail(youtubeId);
    } else {
      this.setState({
        thumbnail: undefined,
        inError: true,
      });
    }
  }

  onClear(evt) {
    evt.preventDefault();

    this.setState({
      value: '',
      thumbnail: undefined,
      inError: false,
      loading: false,
    });
  }

  getValue() {
    return this.state.value;
  }

  _loadYoutubeThumbnail(id) {
    if (id) {
      fetch(`/youtube/${id}`)
        .then(res => res.json())
        .then(json => {
          this.setState({
            thumbnail: json.thumbnail,
            loading: false,
          });
        });
    }
  }

  render() {
    const { name, title } = this.props;
    const { value, thumbnail, loading, inError } = this.state;

    const fieldClass = cx('field', {
      error: inError,
    });
    const inputClass = cx('ui input', {
      action: !!value,
    });

    return (
      <div className="ui basic segment">
        {loading && (
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Chargement de la vidéo</div>
          </div>
        )}
        <div className="ui items">
          <div className="item">
            <div className="ui small image">
              <AsyncImage src={videoThumbnailUrl(thumbnail)} />
            </div>
            <div className="middle aligned content">
              <div className={fieldClass}>
                <label>{title}</label>
                <div className={inputClass}>
                  <input
                    type="url"
                    name={name}
                    value={value}
                    onChange={this.onChangeLink}
                    placeholder="http://www.youtube.com/watch?v="
                  />
                  {value && (
                    <button
                      className="ui red icon button"
                      onClick={this.onClear}
                    >
                      <i className="remove icon" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/YoutubeVideo.js